import React, { useEffect, useState } from "react";
import axios from "axios";

const DBFetch = (url) => {
    let [data, setData] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
            const response = await axios(url);
            const posts = await response;
            posts && setData(posts.data);
        };
        fetchData();
    }, [url]); // wait url variable

    // Return data
    return data;
    
};
export default DBFetch;
